import { render } from "./serviceExplain.vue?vue&type=template&id=ed803e04&scoped=true&ts=true"
import script from "./serviceExplain.vue?vue&type=script&lang=ts"
export * from "./serviceExplain.vue?vue&type=script&lang=ts"

import "./serviceExplain.vue?vue&type=style&index=0&id=ed803e04&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed803e04"]])

export default __exports__